<template>
    <div class="page-list">
        <div class="page-list-inner" v-if="list">
            <div class="top">
                <div class="top-inner">
                    <h4>红包总额</h4>
                    <p v-if="!list.length">你还没有红包哦，快去参加活动领红包吧</p>
                    <span v-else>￥{{amountTotal}}</span>
                </div>
            </div>
            <div class="main">
                <ul v-if="list.length">
                    <li v-for="item in list">
                        <div class="img">
                            <img src="../assets/img/list_hb_icon.png" alt="">
                        </div>
                        <div class="info">
                            <p>{{item.name}}</p>
                            <span>{{item.luckTime}}</span>
                        </div>
                        <b :class="[item.state == 1 && 'can-open']" @click="open(item)">{{item.state == 1 ? '待拆' : '+' + item.amount}}</b>
                    </li>
                </ul>
                <p v-else class="empty">暂无记录</p>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'

import Moment from 'moment'

interface listOptions {
    pid: string;
    name: string;
    type?: string;
    code?: string;
    blhGoodsID?: string;
    amount: number | string;
    state: number;
    luckTime: number | string
}

@Options({
    data () {
        return {
            amountTotal: 0,
            list: null,
            isGeting: false
        }
    },
    computed: {
        ...mapState(['aid', 'userInfo', 'shareData', 'activityData'])
    },
    created () {
        this.getList()
    },
    mounted () {
        this.$common.track(this.aid, 'load', '红包记录页面')
        this.activityData && this.$common.pageLoaded()
        this.shareData.title && this.$common.onshare(this.shareData, this.aid)
    },
    methods: {
        ...mapMutations(['SET_YEARDATA', 'SET_HBDATA']),
        getList () {
            this.$request('/lottery/prize/list', {
                aid: this.aid,
                userinfo: this.userInfo
            }, 'post').then((data: any) => {
                this.list = data.list || []
                this.formatList(this.list)
                this.$common.pageLoaded()
            }).catch(() => {
                this.list = []
            })
        },
        formatList (list: listOptions[]) {
            let amountTotal = 0
            this.list.forEach((val: listOptions, idx: number) => {
                const amount = val.amount as number
                if (val.state === 2) {
                    amountTotal += amount
                }
                val.amount = (amount / 100).toFixed(2)
                val.luckTime = Moment(val.luckTime).format('YYYY年MM月DD日 HH:mm')
                return val
            })
            this.amountTotal = (amountTotal / 100).toFixed(2)
        },
        open (item: listOptions) {
            this.$common.track(this.aid, 'click', '待拆')
            if (item.state == 1) {
                this.getData()
                this.SET_HBDATA(item)
            }
        },
        getData () {
            if (this.isGeting) return
            this.isGeting = true
            this.$request('/year-report-2020', {
                aid: this.aid,
                userinfo: this.userInfo
            }, 'post').then((data: any) => {
                if (data && data.import_time) {
                    this.formatData(data)
                }
                this.isGeting = false
            }).catch((res: any) =>  {
                this.isGeting = false
            })
        },
        formatData (data: any) {
            let newData = JSON.parse(JSON.stringify(data))
            const times = ['import_time', 'first_news_view_date', 'first_discuss_date', 'first_share_date', 'first_live_view_date', 'first_dynamic_create_date', 'last_arrive_date', 'use_time_early', 'use_time_lately']
            for (let time of times) {
                newData[time] && (newData[time] = Moment(data[time]).format('YYYY-M-D-H-m').split('-'))
            }
            if (newData.channel_label){
                newData.channel_label = newData.channel_label.split(',')
            }
            this.SET_YEARDATA(newData)
            sessionStorage.setItem('YEARDATA', JSON.stringify(newData))
        },
    }
})
export default class List extends Vue {}
</script>

<style lang="scss">
.page-list {
    min-height: 100%;
    background-color: #fcfcfc;
    .top {
        background-color: #f3f3f3;
        border-bottom: 1px solid #e8e8e8;
        height: 3.194444rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        .top-inner {
            width: 100%;
            text-align: center;
            line-height: 1.4;
        }
        h4 {
            color: #000;
            font-size: .435185rem;
            font-weight: normal; 
            margin-bottom: .231481rem;     
        }
        p {
            color: rgba($color: #000000, $alpha: .6);
            font-size: .37037rem;
        }
        span {
            color: #ff3437;
            font-size: .62037rem;
            font-weight: bold;
            display: block;
        }
    }
    .main {
        ul {
            li {
                display: flex;
                padding: .324074rem .574074rem;
                align-items: center;
                border-bottom: 1px solid #c9c9c9;
                .img {
                    margin-right: .462963rem;
                    flex-shrink: 0;
                    width: .518519rem;
                    font-size: 0;
                }
                b {
                    flex-shrink: 0;
                    font-size: .37037rem;
                    color: #ff3437;
                    padding: 0 .462963rem;
                    &.can-open {
                        color: #fff;
                        background-color: #ff3437;
                        height: .740741rem;
                        display: flex;
                        align-items: center;
                        border-radius: .37037rem;
                    }
                }
                .info {
                    line-height: 1.4;
                    flex: 1;
                    overflow: hidden;
                    p {
                        color: #000;
                        font-size: .37037rem;
                        margin-bottom: .092593rem;
                    }
                    span {
                        color: rgba($color: #000000, $alpha: .6);
                        font-size: .277778rem;
                        display: block;
                    }
                }
            }
        }
        .empty {
            font-size: .435185rem;
            color: rgba($color: #000000, $alpha: .6);
            text-align: center;
            padding-top: 4.62963rem;
        }
    }
}
</style>